(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockPostleitzahlOrt', {
            require: {
                form: '^form'
            },
            bindings: {
                name: '@name',
                model: '<abpoModel',
                modelProperties: '<abpoModelProperties',
                options: '<abpoOptions'
            },
            transclude: {
                tooltip: '?tooltip'
            },
            templateUrl: 'bloecke/postleitzahl/blockPostleitzahlOrt.html',
            controller: blockPostleitzahlOrtController,
            controllerAs: 'blockPostleitzahlOrtVm'
        });

    blockPostleitzahlOrtController.$inject = [
        '$q',
        'lodash',
        'AdresseUtilsService',
        'MiscUtilsService',
        'LoadingIndicatorService'
    ];
    function blockPostleitzahlOrtController($q, _, AdresseUtilsService, MiscUtilsService, LoadingIndicatorService) {
        var vm = this,
            formFieldNames = [
                'postleitzahl',
                'ort'
            ];

        vm.$onInit = onInit;

        vm.getOrt = getOrt;
        vm.setOrt = setOrt;
        vm.existsPlz = existsPlz;
        vm.isOrtErlaubt = isOrtErlaubt;
        vm.isOrtDisabled = isOrtDisabled;

        function activate() {
            vm.orteZurPlz = [];
            vm.getOrt(_.get(vm.model, vm.modelProperties.plz)).catch(function (error) {});
            vm.labelPostleitzahl = _.get(vm.options, 'labelPostleitzahl') || 'Postleitzahl';
        }

        function onInit() {
            vm.uuid = MiscUtilsService.guid('#');
            vm.shouldOrtBeFocused = false;
            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    fieldName,
                    vm.uuid
                ].join('_');
            }));

            activate();
        }
        function getOrt(postleitzahl, isChangeEvent) {
            if (MiscUtilsService.isEmpty(postleitzahl)) {
                vm.shouldOrtBeFocused = false;
                setOrt();
                vm.plzRequestIsPending = false;
                return $q.resolve([]);
            }
            if (isChangeEvent) {
                setOrt();
            }

            vm.plzRequestIsPending = true;

            LoadingIndicatorService.addInProgress();

            return $q(function (resolve, reject) {
                AdresseUtilsService.existsPlz(postleitzahl).then(function (postleitzahlen) {
                    resolve(postleitzahlen);

                    if (postleitzahlen.length === 1) {
                        vm.orteZurPlz = postleitzahlen;
                        setOrt(postleitzahlen[0]);
                    } else {
                        vm.orteZurPlz = postleitzahlen;
                    }
                }).catch(function (error) {
                    reject(error);
                    vm.orteZurPlz = [];
                    setOrt({});
                }).finally(function () {
                    vm.plzRequestIsPending = false;
                    LoadingIndicatorService.removeInProgress();

                    if (isChangeEvent && _.size(vm.orteZurPlz) > 1) {
                        vm.shouldOrtBeFocused = true;
                    }
                });
            }).catch(function (error) {});
        }
        function setOrt(ort) {
            vm.model.ort = _.get(ort, 'bezeichnung');
        }
        function existsPlz(postleitzahl) {
            return $q(function (resolve, reject) {
                return AdresseUtilsService.existsPlz(postleitzahl).then(function (postleitzahlen) {
                    resolve(postleitzahlen);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function isOrtErlaubt() {
            return (
                vm.model.plz &&
                (
                    !vm.model.ort || _.size(vm.orteZurPlz) >= 1
                ) &&
                !vm.plzRequestIsPending
            );
        }
        function isOrtDisabled() {
            return (
                _.size(vm.orteZurPlz) === 1
            );
        }

    }

})();
